module.exports = __webpack_public_path__ + "static/img/header2.f7c5d90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/header2.jpg
// module id = xQyk
// module chunks = 1